import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "fl" }
const _hoisted_3 = { class: "fw600 fs12 mt4" }
const _hoisted_4 = { class: "fw600 fs12 mt4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!

  return (_ctx.rule)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`w100 pad5 ${_ctx.mfindex % 2 == 0 ? `llgreyBg` : ``}`),
          style: {"height":"70px"}
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.rule.copy_pub_room_public_id), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.rule.copy_pub_room_title), 1),
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rule.group_tags, (tag, tagindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(`fl mr10 mb10 pointer fw600 fs10 rad6 padw3`),
                    key: `tag${tagindex}`
                  }, [
                    _createElementVNode("div", {
                      class: "rad5 fl",
                      style: _normalizeStyle({ background: `#${tag.color}`, width: `10px`, height: `10px`, marginRight: `5px` })
                    }, "   ", 4),
                    _createTextVNode(" " + _toDisplayString(tag.name), 1)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_6
          ]),
          _createElementVNode("p", {
            class: "fr pointer mt2",
            style: {"width":"14px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeRule(_ctx.rule)))
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
              width: "14",
              height: "17"
            }, null, 8, _hoisted_7)
          ]),
          _createVNode(_component_Switcher, {
            value: "type[active]",
            name: "無効",
            checked: _ctx.rule.is_active,
            display: "true",
            class: "checkUsingCal fr mt10 mr10",
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActive(_ctx.rule)))
          }, null, 8, ["checked"]),
          _createElementVNode("span", {
            class: "circle_button fr skyblueBg rad4 fs11 mt12 mr10",
            style: {"padding":"4px 8px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editContent(_ctx.rule)))
          }, " 編集 "),
          _hoisted_8
        ], 2)
      ]))
    : _createCommentVNode("", true)
}